import axios, { type AxiosError, isAxiosError } from 'axios'

export const api = axios.create({
  baseURL: '',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
})

api.interceptors.request.use(config => {
  config.headers['x-request-id'] = crypto.randomUUID()
  return config
})

/** an axios error carries the failing endpoint here once it passes through the
 * response interceptor. read by the react-query cache reporters. */
export type EndpointStamped = { endpoint?: string }

/** stamp `METHOD /path` onto an axios error so downstream capture reports the
 * endpoint without re-deriving it. cancellations get stamped too but are
 * filtered before capture, so there's no need to special-case them here.
 * returns the same error for chaining. */
export function stampEndpoint(error: unknown): unknown {
  if (isAxiosError(error) && error.config) {
    const method = error.config.method?.toUpperCase() ?? 'GET'
    ;(error as AxiosError & EndpointStamped).endpoint =
      `${method} ${error.config.url ?? ''}`.trim()
  }
  return error
}

/** single chokepoint for axios response failures: stamp the endpoint, re-reject. */
api.interceptors.response.use(
  response => response,
  (error: unknown) => Promise.reject(stampEndpoint(error))
)
